import { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function FormModule() {

  const navigate = useNavigate();
  const token = localStorage.getItem("accessToken");

  const [modules, setModules] = useState([]);
  const [search, setSearch] = useState("");

  const [openForm, setOpenForm] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const [formData, setFormData] = useState({
    module_name: "",
    description: "",
    icon: "",
    order: ""
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  /* ============================
        GET ALL MODULES
  ============================ */

  const fetchModules = async () => {
    
    try {

      const response = await axios.get(
        `${API_BASE_URL}/api/elearning_settings/modules/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setModules(response.data.results || response.data);

    } catch (error) {
      console.log("MODULE LIST ERROR:", error.response);
    }
  };

  useEffect(() => {
    fetchModules();
  }, []);

  /* ============================
        GET MODULE BY ID
  ============================ */

  const fetchModuleById = async (id) => {

  try {

    const response = await axios.get(
      `${API_BASE_URL}/api/elearning_settings/modules/${id}/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = response.data;

    setFormData({
      module_name: data.module_name || "",
      description: data.description || "",
      icon: data.icon || "",
      order: data.order || ""
    });

    setEditId(id);
    setOpenForm(true);

  } catch (error) {
    console.log("MODULE DETAIL ERROR:", error.response);
  }
};

  /* ============================
        CREATE MODULE
  ============================ */

  const createModule = async () => {

    try {

      await axios.post(
        `${API_BASE_URL}/api/elearning_settings/modules/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSnackbarMessage("Module created successfully");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);

      setOpenForm(false);
      fetchModules();

    } catch (error) {
      console.log("MODULE CREATE ERROR:", error.response);
    }
  };

  /* ============================
        UPDATE MODULE
  ============================ */
const updateModule = async () => {

  // ✅ ADD DEBUG HERE
  console.log("EDIT ID:", editId);
  console.log("FORM DATA:", formData);

  try {

    await axios.put(
      `${API_BASE_URL}/api/elearning_settings/modules/${editId}/`,
      {
        module_name: formData.module_name,
        description: formData.description,
        icon: formData.icon,
        order: Number(formData.order)
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setSnackbarMessage("Module updated successfully");
    setSnackbarSeverity("success");
    setOpenSnackbar(true);

    setOpenForm(false);
    fetchModules();

  } catch (error) {
    console.log("MODULE UPDATE ERROR:", error.response);
  }
};
  /* ============================
        DELETE MODULE
  ============================ */

  const confirmDelete = async () => {

    try {

      await axios.delete(
        `${API_BASE_URL}/api/elearning_settings/modules/${deleteId}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSnackbarMessage("Module deleted successfully");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);

      setOpenDelete(false);
      fetchModules();

    } catch (error) {
      console.log("MODULE DELETE ERROR:", error.response);
    }
  };

  /* ============================
        SEARCH FILTER
  ============================ */

  const filteredModules = modules.filter((m) =>
    m.module_name?.toLowerCase().includes(search.toLowerCase())
  );

  return (

    <Paper
      sx={{
        p: 4,
        borderRadius: 3,
        boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
      }}
    >

      {/* HEADER */}

      <Typography variant="h5" fontWeight="bold" mb={3}>
        Module Details
      </Typography>

      {/* SEARCH + ADD */}

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 2,
        }}
      >

        <TextField
          size="small"
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <Button
          variant="contained"
          onClick={() => {

            setEditId(null);

            setFormData({
              module_name: "",
              description: "",
              icon: "",
              order: ""
            });

            setOpenForm(true);
          }}
        >
          ADD MODULE
        </Button>

      </Box>

      {/* TABLE */}

      <TableContainer>

        <Table>

          <TableHead>

            <TableRow>

              <TableCell>S.No</TableCell>
              <TableCell>Module Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Icon</TableCell>
              <TableCell>Order</TableCell>
              <TableCell>Action</TableCell>

            </TableRow>

          </TableHead>

          <TableBody>

            {filteredModules.map((row, index) => (

            <TableRow key={row.module_id || row.id}>

                <TableCell>{index + 1}</TableCell>
                <TableCell>{row.module_name}</TableCell>
                <TableCell>{row.description}</TableCell>
                <TableCell>{row.icon}</TableCell>
                <TableCell>{row.order}</TableCell>

                <TableCell>

                  <Button
                    size="small"
                    sx={{ mr: 1 }}
                    onClick={() => fetchModuleById(row.module_id || row.id)}
                  >
                    EDIT
                  </Button>

                  <Button
                    size="small"
                    color="error"
                    variant="contained"
                    onClick={() => {
                      setDeleteId(row.module_id || row.id);
                      setOpenDelete(true);
                    }}
                  >
                    DELETE
                  </Button>

                </TableCell>

              </TableRow>

            ))}

            {filteredModules.length === 0 && (

              <TableRow>

                <TableCell colSpan={6} align="center">
                  No modules found
                </TableCell>

              </TableRow>

            )}

          </TableBody>

        </Table>

      </TableContainer>

      {/* ADD / EDIT FORM */}

      <Dialog open={openForm} onClose={() => setOpenForm(false)}>

        <DialogTitle>
          {editId ? "Edit Module" : "Add Module"}
        </DialogTitle>

        <DialogContent>

          <TextField
            fullWidth
            label="Module Name"
            margin="dense"
            value={formData.module_name}
            onChange={(e) =>
              setFormData({ ...formData, module_name: e.target.value })
            }
          />

          <TextField
            fullWidth
            label="Description"
            margin="dense"
            value={formData.description}
            onChange={(e) =>
              setFormData({ ...formData, description: e.target.value })
            }
          />

          <TextField
            fullWidth
            label="Icon"
            margin="dense"
            value={formData.icon}
            onChange={(e) =>
              setFormData({ ...formData, icon: e.target.value })
            }
          />

          <TextField
            fullWidth
            label="Order"
            margin="dense"
            value={formData.order}
            onChange={(e) =>
              setFormData({ ...formData, order: e.target.value })
            }
          />

        </DialogContent>

        <DialogActions>

          <Button onClick={() => setOpenForm(false)} data-app-cancel="true">
            Cancel
          </Button>

          {editId ? (
            <Button variant="contained" onClick={updateModule}>
              Update
            </Button>
          ) : (
            <Button variant="contained" onClick={createModule}>
              Save
            </Button>
          )}

        </DialogActions>

      </Dialog>

      {/* DELETE CONFIRM */}

      <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>

        <DialogTitle>Confirm Delete</DialogTitle>

        <DialogContent>
          Are you sure you want to delete this module?
        </DialogContent>

        <DialogActions>

          <Button onClick={() => setOpenDelete(false)} data-app-cancel="true">
            Cancel
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={confirmDelete}
          >
            Delete
          </Button>

        </DialogActions>

      </Dialog>

      {/* SNACKBAR */}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >

        <Alert
          severity={snackbarSeverity}
          onClose={() => setOpenSnackbar(false)}
        >
          {snackbarMessage}
        </Alert>

      </Snackbar>

    </Paper>
  );
}

export default FormModule;